import * as React from "react";
import styled from "styled-components";

const ScrollContainerDiv = styled.div`
    overflow${({ direction }) => direction}:auto;
    position:relative;

    &::-webkit-scrollbar-track {
    }

    &::-webkit-scrollbar {
        width: 10px;
        height: 10px;
    }

    &::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background: -webkit-linear-gradient(${({ direction }) => (direction == "-y" ? "90deg" : "180deg")} ,rgb(216, 215, 215) 44%, rgb(81, 81, 81) 86%);
    }
`;

const ScrollContainer = ({ children, direction, style }) => {
    return (
        <ScrollContainerDiv id="scrollContainer" direction={direction} style={style}>
            {children}
        </ScrollContainerDiv>
    );
};

export default ScrollContainer;
